<template>
  <div class="modal-overlay">

    <div class="modal-card">

      <!-- HEADER -->
      <div class="modal-header">
        <div>
          <h2>Add New Customer</h2>
          <p>Create customer profile for campaigns & tracking</p>
        </div>

        <button class="close-btn" @click="$emit('close')">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <!-- BODY -->
      <div class="modal-body">

        <div class="form-grid">

          <div class="input-group">
            <label>Full Name</label>
            <input v-model="customer.name" placeholder="John Doe"/>
          </div>

          <div class="input-group">
            <label>Email Address</label>
            <input v-model="customer.email" placeholder="john@email.com"/>
          </div>

          <div class="input-group" style="margin-top: 1rem;">
            <label>Phone Number</label>
            <input v-model="customer.phone" placeholder="+1 234 567 890"/>
          </div>
           <div class="input-group" style="margin-top: 1rem;">
          <label>Tags</label>

          <div class="tags-row">
            <span
              v-for="tag in availableTags"
              :key="tag"
              :class="{ active: customer.tags.includes(tag) }"
              @click="toggleTag(tag)"
            >
              {{ tag }}
            </span>
          </div>
        </div>
        </div>

        <!-- TAGS -->
       

      </div>
    
      <!-- FOOTER -->
      <div class="modal-footer">

        <button class="ghost-btn" @click="$emit('close')">
          Cancel
        </button>

        <button class="primary-btn" @click="saveCustomer" :disabled="loading">
            <span v-if="loading" class="material-symbols-outlined spin">progress_activity</span>
          {{ loading ? "Saving..." : editData ? "Update Customer" : "Save Customer"  }}
        </button>

      </div>

    </div>
  </div>
</template>
<script>
import { createCustomer } from "../apis/customerapis";
import { useToast } from "vue-toastification";

export default {
  name: "AddCustomerModal",

  data() {
    return {
      toast: useToast(),

      loading: false,
      ldata:null,
      customer: {
        user_id:'',
        name: '',
        email: '',
        phone: '',
        tags: []
      },
      availableTags: ["VIP", "Loyal", "Referral"]
    };
  },
  props: {
  editData: {
    type: Object,
    default: null
  }
},
mounted() {
  const ldataRaw = sessionStorage.getItem('ldata');
  this.ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
  if (this.editData) {
    this.customer = {
      user_id: this.editData.user_id,
      name: this.editData.user_name,
      email: this.editData.user_email,
      phone: this.editData.user_mobile,
      tags: this.editData.user_tags
        ? this.editData.user_tags.split(",")
        : []
    };
  }
},
  methods: {

    toggleTag(tag) {
      const exists = this.customer.tags.includes(tag);

      if (exists)
        this.customer.tags = this.customer.tags.filter(t => t !== tag);
      else
        this.customer.tags.push(tag);
    },

    /* ✅ VALIDATION */
    validateForm() {

      if (!this.customer.name) {
        this.toast.error("Customer name required");
        return false;
      }

      if (this.customer.email && !this.customer.email.includes("@")) {
        this.toast.error("Invalid email address");
        return false;
      }

      return true;
    },

    /* ✅ API SAVE */
    async saveCustomer() {

      if (!this.validateForm()) return;

      this.loading = true;

      try {

        const res = await createCustomer(
          this.customer.user_id,
          this.customer.name,
          this.customer.email,
          this.customer.phone,
          this.customer.tags.join(","),
          this.ldata.user_id  // ✅ matches DB TEXT column
        );

        if (res.status) {

          this.toast.success(res.success || "Customer created");

          this.$emit("refresh");  // ✅ reload list
          this.$emit("close");

        } else {
          this.toast.error(res.success || "Failed to create customer");
        }

      } catch (err) {

        console.error(err);
        this.toast.error("Server error");

      }

      this.loading = false;
    }
  }
};
</script>
<style scoped>

/* OVERLAY */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}

/* CARD */
.modal-card {
  width: 520px;
  background: white;
  border-radius: 18px;
  box-shadow: 0 40px 90px rgba(0,0,0,0.18);
  overflow: hidden;
  animation: modalIn 0.2s ease;
}

/* HEADER */
.modal-header {
  padding: 22px 26px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
}

.modal-header h2 {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.modal-header p {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 3px;
}

/* BODY */
.modal-body {
  padding: 22px 26px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

/* INPUTS */
.input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.input-group label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #94a3b8;
}

.input-group input {
  height: 38px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 0 10px;
  font-size: 13px;
  outline: none;
}

.input-group input:focus {
  border-color: #197fe6;
}

/* TAGS */
.tags-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 6px;
}

.tags-row span {
  padding: 6px 10px;
  border-radius: 20px;
  background: #f1f5f9;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.15s;
}

.tags-row span.active {
  background: #197fe6;
  color: white;
}

/* FOOTER */
.modal-footer {
  padding: 16px 26px;
  background: #f8fafc;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid #f1f5f9;
}

/* CLOSE */
.close-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  cursor: pointer;
}

.close-btn:hover {
  background: #f1f5f9;
}

/* ANIMATION */
@keyframes modalIn {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

/* MOBILE */
@media(max-width:640px) {
  .modal-card {
    width: 95%;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }
}

/* Extend modal width */
.wizard-card {
  width: 760px; /* slightly wider like real wizard */
  border-radius: 20px;
  box-shadow: 0 35px 90px rgba(0,0,0,0.18);
}

/* HEADER */
.wizard-header {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 18px;
}

/* Progress Block */
.progress-block span {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #197fe6;
  letter-spacing: 0.6px;
}

/* Progress Bar */
.progress-bar {
  height: 6px;
  background: #f1f5f9;
  border-radius: 30px;
  margin-top: 8px;
}

.progress-bar div {
  width: 66%;
  height: 100%;
  background: linear-gradient(90deg, #197fe6, #3b82f6);
  border-radius: 30px;
  transition: 0.3s ease;
}

/* Step Indicator */
.step-indicator {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  background: #f1f5f9;
  padding: 6px 10px;
  border-radius: 20px;
}

/* BODY */
.wizard-body {
  padding-top: 34px;
}

/* Title */
.wizard-title h2 {
  font-size: 26px;
  font-weight: 900;
  color: #0f172a;
}

.wizard-title p {
  font-size: 14px;
  color: #64748b;
  margin-top: 8px;
}

/* GRID */
.channel-grid {
  margin-top: 26px;
}

/* CARD */
.channel-card {
  border: 2px solid #f1f5f9;
  border-radius: 16px;
  padding: 26px 20px;
  cursor: pointer;
  transition: 0.22s;
  text-align: center;
  background: white;
}

.channel-card:hover {
  border-color: rgba(25,127,230,0.45);
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(0,0,0,0.06);
}

.channel-card.active {
  border-color: #197fe6;
  background: linear-gradient(180deg, #f0f7ff, #f8fbff);
  box-shadow: 0 10px 30px rgba(25,127,230,0.12);
}

/* ICON */
.icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: linear-gradient(135deg, #f0f7ff, #e6f0ff);
  margin: 0 auto 14px;
}

.icon-wrap span {
  font-size: 28px;
}

/* TEXT */
.channel-card h3 {
  font-size: 17px;
  font-weight: 800;
}

.channel-card p {
  font-size: 13px;
  color: #64748b;
  margin-top: 4px;
}

/* FOOTER */
.wizard-footer {
  background: white;
  border-top: 1px solid #f1f5f9;
  padding-top: 18px;
}

/* BUTTONS (Premium SaaS Style) */

.ghost-btn {
  height: 42px;
  padding: 0 18px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: white;
  font-size: 13px;
  font-weight: 700;
  color: #475569;
  transition: 0.2s;
}

.ghost-btn:hover {
  border-color: #197fe6;
  color: #197fe6;
  background: #f8fbff;
}

.primary-btn {
  height: 42px;
  padding: 0 22px;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(135deg, #197fe6, #3b82f6);
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.3px;
  box-shadow: 0 12px 25px rgba(25,127,230,0.35);
  transition: 0.22s;
}

.primary-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 32px rgba(25,127,230,0.45);
}

.primary-btn:active {
  transform: scale(0.97);
}

/* MOBILE */
@media(max-width:768px) {
  .wizard-card {
    width: 95%;
  }

  .channel-grid {
    grid-template-columns: 1fr;
  }

  .wizard-title h2 {
    font-size: 22px;
  }
}
.spin {
  animation: spin 1s linear infinite;
  font-size: 18px;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>

